import React, { useCallback, useEffect, useState } from "react";
import { Layout, Row, Col, Form, Spin } from "antd";
import { useLocation } from "react-router-dom";
import PageHeaderSection from "./components/PageHeader";
import ShareholderInfoCard from "./components/ShareholderInfoCard";
import DocumentCard from "./components/DocumentCard";
import VotingCard from "./components/VotingCard";
import UnauthorizedView from "./components/UnauthorizedView";

const { Content, Footer } = Layout;
const url = `${process.env.REACT_APP_CRM_ENDPOINT_URL}/vi/api/v1.0/DaiHoiCoDong`;

const DaiHoiCoDong = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const queryParams = new URLSearchParams(location.search);
  const userId = queryParams.get("userId");
  const [shareholder, setShareholder] = useState(null);
  const [isValidUser, setIsValidUser] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const res = await fetch(`${url}/get-by-userid?userId=${userId}`);

      if (!res.ok) {
        throw new Error("API response not ok");
      }

      const json = await res.json();

      if (!json || !json.data || json.data.isGuest) {
        setIsValidUser(false);
        return;
      }

      setShareholder(json.data);
      form.setFieldValue("votes", json.data.bieuQuyets);
      setIsValidUser(true);
      setLoading(false);
    } catch (error) {
      setIsValidUser(false);
      setLoading(false);
    }
  }, [form, userId]);

  useEffect(() => {
    if (!userId) {
      setIsValidUser(false);
      return;
    }

    fetchData();
  }, [fetchData, userId]);

  if (!isValidUser) {
    return <UnauthorizedView fetchData={fetchData} />;
  }

  return (
    <Layout style={{ minHeight: "100vh", background: "#F5F7FA" }}>
      <PageHeaderSection />

      <Content style={{ padding: "40px 24px" }}>
        <Spin spinning={loading} tip="Đang tải...">
          <div style={{ maxWidth: 1200, margin: "0 auto" }}>
            <Row gutter={[32, 32]}>
              <Col xs={24} md={9}>
                <ShareholderInfoCard data={shareholder} />
                <div style={{ height: 24 }} />
                <DocumentCard data={shareholder?.taiLieus || []} />
              </Col>

              <Col xs={24} md={15}>
                <VotingCard
                  form={form}
                  questions={shareholder?.bieuQuyets || []}
                  submitted={shareholder?.isConfirmBieuQuyet || false}
                  userId={userId}
                  fetchData={fetchData}
                  url={url}
                />
              </Col>
            </Row>
          </div>
        </Spin>
      </Content>

      <Footer
        style={{
          textAlign: "center",
          background: "#219737",
          color: "#fff",
        }}
      >
        © 2026 Công ty CP Medic Holding | Đại hội cổ đông trực tuyến
      </Footer>
    </Layout>
  );
};

export default DaiHoiCoDong;
